// extracted by mini-css-extract-plugin
export default {"root":"InkkYa","checkbox":"fBQf_j","checkboxError":"u2Lkdw"};